export const concatNonEmptyStrings = (items: Array<string | undefined>, separator = ' ') => {
    return items.filter(Boolean).join(separator);
};
